<template>
  <div class="popup-dialog-background" v-if="this.showPopup">
    <div role="dialog" aria-label="System message" aria-describedby="systemmessage:desc" class="popup-dialog" style="" >
      <span id="systemmessage:desc" class="popup-dialog-message" v-html="this.popupMessage"></span>
      <div class="popup-dialog-button-container">
        <button type="button" tabindex="0" class="popup-dialog-btn" ref="dialogButton" @click="clickConsent()">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies';
import { mapGetters } from "vuex";
export default {
  name: "app-popup-message",
  props: { },
  data: function() {
    return {
      popupMessage: '',
      showPopup: false,
      seenPopupCookieName:"popup-seen"
    };
  },
  mounted(){
    window.addEventListener('keydown',this.closeOnEscape);
  },
  beforeDestroy() {
      window.removeEventListener('keydown', this.closeOnEscape);
  },
  methods:{
    clickConsent(){
      VueCookies.set(this.seenPopupCookieName, "true",{expires: ''});
      this.showPopup = false;
    },
    closeOnEscape(event){
      if(event.keyCode == 27){
        this.clickConsent();
      }
    }
  },
  computed: {
    ...mapGetters(["getShowPopup","getPopupMessage"])
  },
  watch: {
    getShowPopup(newValue){
      this.showPopup = newValue.toUpperCase()==='TRUE' && (!VueCookies.isKey(this.seenPopupCookieName) || VueCookies.get(this.seenPopupCookieName)=="false");
    },
    getPopupMessage(newValue){
      this.popupMessage = newValue;
    },
    showPopup(newValue){
      if(newValue==true){
        this.$nextTick(()=>{
          this.$refs.dialogButton.focus();
        });
      }
    }
  }
};
</script>
